import React from 'react'
import { Image, ScrollView } from 'react-native'

import { SH1, SH2, Stack, Text } from '@zet/design-system'
import { i18n } from '@zet/localization'

import { useBenefitsData } from '../../utils/constants'

const CreditScoreBenefits = () => {
  const { benefitsData } = useBenefitsData()
  return (
    <Stack className="my-3 ml-3">
      <SH1 className="text-grays-100 mb-3">
        {i18n.t('checkCreditScore.benifitsOfGoodScore')}
      </SH1>
      <ScrollView horizontal showsHorizontalScrollIndicator={false}>
        {benefitsData.map(({ id, imageSource, title, subTitle }) => (
          <Stack
            className="border-grays-30 mr-3 rounded-lg border p-2"
            style={{ width: 250 }}
            key={id}
          >
            <Stack style={{ width: 50, height: 50 }}>
              <Image
                source={imageSource}
                resizeMode="contain"
                style={{ width: 40, height: 40 }}
              />
            </Stack>
            <SH2 className="text-grays-100 font-[Graphie-Bold]">{title}</SH2>
            <Text className="text-grays-100 flex-1">{subTitle}</Text>
          </Stack>
        ))}
      </ScrollView>
    </Stack>
  )
}

export default CreditScoreBenefits
